// Prepared dishes live in state.inventory.dishes. Eating a dish applies its
// recipe's buff for a duration. Dishes are also visible cooking goals.

import { getState, save } from './save.js';
import { RECIPES } from './recipes.js';
import { addBuff } from './buffs.js';

export function getDishes(){ return getState().inventory.dishes || {}; }

export function getDish(id){ return getDishes()[id] || 0; }

export function addDish(id, n = 1){
  const inv = getState().inventory;
  inv.dishes = inv.dishes || {};
  inv.dishes[id] = (inv.dishes[id] || 0) + n;
  save();
  return inv.dishes[id];
}

export function spendDish(id, n = 1){
  const inv = getState().inventory;
  inv.dishes = inv.dishes || {};
  if ((inv.dishes[id] || 0) < n) return false;
  inv.dishes[id] -= n;
  save();
  return true;
}

export function eatDish(id){
  const recipe = RECIPES[id];
  if (!recipe) return { ok: false, reason: 'unknown dish' };
  if (!spendDish(id, 1)) return { ok: false, reason: 'none left' };

  const duration = recipe.duration * 1000; // ms
  for (const [stat, amount] of Object.entries(recipe.buff)){
    addBuff({ stat, amount, duration, source: id });
  }
  return { ok: true, buff: recipe.buff, duration };
}
